(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.SmagtronCalculatorRegistry = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const catalog = {
    profiles: {
      'area-heating-v1': {
        id: 'area-heating-v1',
        kind: 'area',
        status: 'pilot',
        title: 'Heizungsfolie konfigurieren',
        pricingMode: 'server-variant',
        currency: 'EUR',
        formula: { baseCents: 370, areaDivisor: 10000, rateCents: 90 },
        width: { min: 300, max: 2490, initial: 600, decimals: 0 },
        height: { min: 300, max: 990, initial: 300, decimals: 0 },
        modules: ['area']
      },
      'area-electrical-box-v1': {
        id: 'area-electrical-box-v1',
        kind: 'area',
        status: 'pilot',
        title: 'Stromkastenfolie konfigurieren',
        pricingMode: 'server-variant',
        currency: 'EUR',
        formula: { baseCents: 970, areaDivisor: 10000, rateCents: 80 },
        width: { min: 100, max: 1000, initial: 500, decimals: 0 },
        height: { min: 100, max: 2490, initial: 500, decimals: 0 },
        modules: ['area']
      },
      'complex-family-time-v1': {
        id: 'complex-family-time-v1', kind: 'fixed-options', status: 'pilot',
        title: 'Family Time konfigurieren', pricingMode: 'server-variant', currency: 'EUR',
        chalkPrices: { black: 0, white: 0, four: 1000, eight: 1900 },
        modules: ['visual-choice', 'dropdown', 'text', 'addon']
      },
      'area-heating-upload-service-v1': {
        id: 'area-heating-upload-service-v1', kind: 'area', status: 'pilot',
        title: 'Heizungsfolie mit eigenem Motiv konfigurieren', pricingMode: 'server-variant',
        currency: 'EUR',
        formula: { baseCents: 370, areaDivisor: 10000, rateCents: 90 },
        width: { min: 300, max: 2490, initial: 600, decimals: 0 },
        height: { min: 300, max: 990, initial: 300, decimals: 0 },
        upload: { key: 'artwork', property: 'Eigenes Motiv', required: true, maxFiles: 1 },
        choices: [{
          key: 'graphicsService', property: 'Grafikservice', required: true,
          values: [
            { key: 'quick', label: 'Quick-Service', priceCents: 0 },
            { key: 'expert', label: 'Experten-Service', priceCents: 2000 }
          ]
        }],
        modules: ['area', 'upload', 'service']
      },
      'area-electrical-box-upload-v1': {
        id: 'area-electrical-box-upload-v1', kind: 'area', status: 'pilot',
        title: 'Magnetpinnwand mit eigenem Motiv konfigurieren', pricingMode: 'server-variant',
        currency: 'EUR',
        formula: { baseCents: 970, areaDivisor: 10000, rateCents: 80 },
        width: { min: 100, max: 1000, initial: 500, decimals: 0 },
        height: { min: 100, max: 2490, initial: 500, decimals: 0 },
        upload: { key: 'artwork', property: 'Eigenes Motiv', required: true, maxFiles: 3 },
        choices: [{
          key: 'graphicsService', property: 'Grafikservice', required: true,
          values: [
            { key: 'quick', label: 'Quick-Service', priceCents: 0 },
            { key: 'expert', label: 'Experten-Service', priceCents: 2000 }
          ]
        }],
        modules: ['area', 'upload', 'service']
      },
      'fixed-bier-huat-v1': {
        id: 'fixed-bier-huat-v1', kind: 'fixed-options', status: 'pilot',
        title: 'Bier Huat konfigurieren', pricingMode: 'static-variants',
        modules: ['visual-choice', 'conditional-text', 'visual-choice']
      },
      'area-magnet-print-upload-service-v1': {
        id: 'area-magnet-print-upload-service-v1', kind: 'area', status: 'pilot',
        title: 'Magnetfolie mit eigenem Motiv konfigurieren', pricingMode: 'server-variant',
        currency: 'EUR',
        formula: { baseCents: 370, areaDivisor: 10000, rateCents: 90 },
        width: { min: 300, max: 2490, initial: 600, decimals: 0 },
        height: { min: 300, max: 1000, initial: 300, decimals: 0 },
        upload: { key: 'artwork', property: 'Eigenes Motiv', required: true, maxFiles: 1 },
        choices: [{
          key: 'graphicsService', property: 'Grafikservice', required: true,
          values: [
            { key: 'quick', label: 'Quick-Service', priceCents: 0 },
            { key: 'expert', label: 'Experten-Service', priceCents: 2000 }
          ]
        }],
        modules: ['area', 'upload', 'service']
      },
      'area-electrical-box-upload-approval-v1': {
        id: 'area-electrical-box-upload-approval-v1', kind: 'area', status: 'pilot',
        title: 'Stromkastenfolie mit eigenem Motiv konfigurieren', pricingMode: 'server-variant',
        currency: 'EUR',
        formula: { baseCents: 970, areaDivisor: 10000, rateCents: 80 },
        width: { min: 100, max: 1000, initial: 500, decimals: 0 },
        height: { min: 100, max: 2490, initial: 500, decimals: 0 },
        upload: { key: 'artwork', property: 'Eigenes Motiv', required: true, maxFiles: 3 },
        choices: [
          {
            key: 'graphicsService', property: 'Grafikservice', required: true,
            values: [
              { key: 'quick', label: 'Quick-Service', priceCents: 0 },
              { key: 'expert', label: 'Experten-Service', priceCents: 2000 }
            ]
          },
          {
            key: 'approval', property: 'Vorab-Freigabe', required: true,
            values: [
              { key: 'automatic', label: 'Automatische Freigabe', priceCents: 0 },
              { key: 'customer', label: 'Kunden-Freigabe', priceCents: 200 }
            ]
          }
        ],
        modules: ['area', 'upload', 'service', 'approval']
      },
      'fixed-clock-upload-service-v1': {
        id: 'fixed-clock-upload-service-v1', kind: 'fixed-options', status: 'pilot',
        title: 'Uhr mit eigenem Motiv konfigurieren', pricingMode: 'server-variant', currency: 'EUR',
        upload: { key: 'artwork', property: 'Eigenes Motiv', required: true, maxFiles: 1 },
        servicePrices: { quick: 0, expert: 2000 },
        legacyFormula: 'product_price + graphics_service',
        modules: ['upload', 'service']
      },
      'area-ferrofoil-material-quantity-v1': {
        id: 'area-ferrofoil-material-quantity-v1', kind: 'area-quantity', status: 'pilot',
        title: 'Eisenfolie konfigurieren', pricingMode: 'server-variant',
        legacyFormula: 'material + area_cm2 / 100 / 2 + product_price',
        currency: 'EUR',
        width: { min: 200, max: 2000, initial: 500, decimals: 0 },
        height: { min: 200, max: 1000, initial: 500, decimals: 0 },
        quantity: { min: 1, max: 500, initial: 1 },
        formula: { areaDivisor: 200 },
        executions: [
          { key: 'self-adhesive', label: 'selbstklebend', priceCents: 400 },
          { key: 'non-adhesive', label: 'nicht selbstklebend', priceCents: 100 }
        ],
        materials: [
          { key: 'white-matt', label: 'Weiß Matt', priceCents: 290 },
          { key: 'white-writable', label: 'Weiß Beschreibbar', priceCents: 690 },
          { key: 'brown-raw', label: 'Braun Roh', priceCents: 90 },
          { key: 'brown-self-adhesive', label: 'Braun selbstklebend', priceCents: 390 }
        ],
        incompatibleSelections: [
          { execution: 'self-adhesive', material: 'brown-raw' },
          { execution: 'non-adhesive', material: 'brown-self-adhesive' }
        ],
        modules: ['area', 'visual-choice', 'quantity']
      },
      'area-magnet-quantity-v1': {
        id: 'area-magnet-quantity-v1', kind: 'area-quantity', status: 'pilot',
        title: 'Magnetfolie als Individualzuschnitt konfigurieren', pricingMode: 'server-variant',
        currency: 'EUR',
        width: { min: 10, max: 100, initial: 100, decimals: 1, unit: 'cm' },
        height: { min: 10, max: 62, initial: 62, decimals: 1, unit: 'cm' },
        quantity: { min: 1, max: 500, initial: 1, step: 1 },
        legacyFormula: 'product_price * ((area / 6200) * 1.3 - 0.3 * (area / 6200)^2) * quantity + 4',
        modules: ['area', 'quantity']
      },
      'length-magnet-quantity-v1': {
        id: 'length-magnet-quantity-v1', kind: 'length-quantity', status: 'pilot',
        title: 'Magnetfolie als Rollenware konfigurieren', pricingMode: 'server-variant',
        currency: 'EUR',
        length: { min: 20, max: 1550, initial: 100, decimals: 0, unit: 'cm' },
        quantity: { min: 1, max: 500, initial: 1, step: 1 },
        legacyFormula: '(product_price + 17.9) * length / 100 * quantity',
        modules: ['length', 'quantity']
      },
      'area-pinboard-v1': {
        id: 'area-pinboard-v1', kind: 'area', status: 'pilot',
        title: 'Magnetpinnwand konfigurieren', pricingMode: 'server-variant',
        currency: 'EUR',
        formula: { baseCents: 1390, areaDivisor: 10000, rateCents: 60 },
        width: { min: 100, max: 2490, initial: 500, decimals: 0 },
        height: { min: 100, max: 1000, initial: 500, decimals: 0 },
        modules: ['area']
      },
      'area-label-quantity-v1': {
        id: 'area-label-quantity-v1', kind: 'area-quantity', status: 'pilot',
        title: 'Magnetschilder konfigurieren', pricingMode: 'server-variant',
        currency: 'EUR',
        width: { min: 10, max: 620, initial: 10, decimals: 0, unit: 'mm' },
        height: { min: 10, max: 620, initial: 10, decimals: 0, unit: 'mm' },
        quantity: { min: 25, max: 5000, initial: 25, step: 25 },
        basePriceCents: 500,
        legacyFormula: '(quantity / 25) * (product_price + area / 100)',
        modules: ['quantity', 'area']
      }
    },
    assignments: {
      '687a82a7520d9f59071c08a1': 'area-heating-v1',
      '685ea9c6ae3c409b95dc71ac': 'area-electrical-box-v1',
      '6939e2e4722274effaf12566': 'complex-family-time-v1',
      '68b58728c4d4f8aaf64f13ba': 'area-heating-upload-service-v1',
      '691dd12d73ce04289090e632': 'area-electrical-box-upload-v1',
      '690363f9998180b643b491ee': 'fixed-bier-huat-v1',
      '69dc93da6d907dc91c9a0449': 'area-magnet-print-upload-service-v1',
      '68b1a69499bfb140c6397aa0': 'area-electrical-box-upload-approval-v1',
      '69708eba2b07f5d48d3f956c': 'fixed-clock-upload-service-v1',
      '68f8c16a1f4d70d956b1f04f': 'area-ferrofoil-material-quantity-v1',
      '693061325df1c5c10da349a2': 'area-magnet-quantity-v1',
      '690a746afb8b068e66caf167': 'length-magnet-quantity-v1',
      '68c2efe8c7fe5546b6aacc49': 'area-pinboard-v1',
      '69c1931b32ce48439d8f81c6': 'area-label-quantity-v1'
    },
    productOverrides: {}
  };

  function createRegistry(definition) {
    const source = definition || {};
    const profiles = source.profiles || {};
    const assignments = source.assignments || {};
    const productOverrides = source.productOverrides || {};

    return {
      audit() {
        const profileIds = Object.keys(profiles);
        const assignedProfileIds = Object.values(assignments);
        return {
          profileCount: profileIds.length,
          assignmentCount: Object.keys(assignments).length,
          danglingProfileIds: [...new Set(assignedProfileIds.filter((id) => !profiles[id]))]
        };
      },
      resolve(input, options) {
        const request = input || {};
        const settings = options || {};
        const profileId = request.profileId || productOverrides[request.productHandle] || assignments[request.legacyConfigurationId];
        if (!profileId) return { ok: false, reason: 'unassigned' };
        const profile = profiles[profileId];
        if (!profile) return { ok: false, reason: 'profile-missing', profileId };
        if (settings.allowedStatuses && !settings.allowedStatuses.includes(profile.status)) {
          return { ok: false, reason: 'profile-not-ready', profileId, status: profile.status };
        }
        return { ok: true, profile };
      }
    };
  }

  return { catalog, createRegistry };
});
